import { LicenseName } from "@/data/license.data";

export abstract class LimiterWithUniqueLimitsBase<T> {
  abstract getUniqueLimit(userId: string): Promise<T | null>;

  abstract getPlanLimit(license: LicenseName): T;

  async getLimit(userId: string, license: LicenseName): Promise<T> {
    if (!userId) {
      return this.getPlanLimit(license);
    }

    const limit = await this.getUniqueLimit(userId);
    if (limit) {
      return limit;
    }
    return this.getPlanLimit(license);
  }
}

export abstract class LimiterWithUniqueLimits extends LimiterWithUniqueLimitsBase<number> {}
